"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CurveStablePoolCode = void 0;
const chain_1 = require("@zenlink-interface/chain");
const tiny_invariant_1 = __importDefault(require("tiny-invariant"));
const viem_1 = require("viem");
const HEXer_1 = require("../../HEXer");
const PoolCode_1 = require("./PoolCode");
const NATIVE_POOLS = [].map((p) => p.toLowerCase());
class CurveStablePoolCode extends PoolCode_1.PoolCode {
    constructor(pool, providerName) {
        super(pool, providerName);
        this.dispatcher = {
            [chain_1.ParachainId.ARBITRUM_ONE]: '0x1B5a2f88420ff329406D108e641e52E46465F68e',
        };
        this.executor = {
            [chain_1.ParachainId.MOONBEAM]: '0x79A22c8b3e3d29d466FF309692954e10652c2cAF',
            [chain_1.ParachainId.BASE]: '0xf6EA707CBf38f2Acf3bf029429B55192c61c67ad',
        };
    }
    getStartPoint() {
        const chainId = this.pool.token0.chainId;
        (0, tiny_invariant_1.default)(chainId !== undefined, 'CurveStablePoolCode: Unseted chainId');
        return this.dispatcher[Number(chainId)];
    }
    getProtocolExecutor() {
        const chainId = this.pool.token0.chainId;
        (0, tiny_invariant_1.default)(chainId !== undefined, 'CurveStablePoolCode: Unseted chainId');
        return this.executor[Number(chainId)];
    }
    getProtocolExecutorStartPoint() {
        return this.getProtocolExecutor();
    }
    getSwapCodeForRouteProcessor(_leg, _route, _to) {
        return 'unsupported';
    }
    getSwapCodeForRouteProcessor2(leg, _route, to) {
        const tokenFromIndex = leg.tokenFrom.address?.toLowerCase() === this.pool.token0.address?.toLowerCase()
            ? this.pool.token0Index
            : this.pool.token1Index;
        const tokenToIndex = leg.tokenTo.address?.toLowerCase() === this.pool.token0.address?.toLowerCase()
            ? this.pool.token0Index
            : this.pool.token1Index;
        const poolData = (0, viem_1.encodeAbiParameters)((0, viem_1.parseAbiParameters)('address, bool, int128, int128, address'), [
            leg.poolAddress,
            NATIVE_POOLS.includes(leg.poolAddress.toLowerCase()),
            BigInt(tokenFromIndex),
            BigInt(tokenToIndex),
            leg.tokenTo.address,
        ]);
        const code = new HEXer_1.HEXer()
            .uint8(7) // curve stable pool
            .bool(false) // isMetaSwap
            .address(to)
            .bytes(poolData)
            .toString();
        return code;
    }
    getSwapCodeForAggregationRouter(leg, _route, to) {
        const tokenFromIndex = leg.tokenFrom.address?.toLowerCase() === this.pool.token0.address?.toLowerCase()
            ? this.pool.token0Index
            : this.pool.token1Index;
        const tokenToIndex = leg.tokenTo.address?.toLowerCase() === this.pool.token0.address?.toLowerCase()
            ? this.pool.token0Index
            : this.pool.token1Index;
        const poolData = (0, viem_1.encodeAbiParameters)((0, viem_1.parseAbiParameters)('address, bool, int128, int128, address'), [
            leg.poolAddress,
            NATIVE_POOLS.includes(leg.poolAddress.toLowerCase()),
            BigInt(tokenFromIndex),
            BigInt(tokenToIndex),
            leg.tokenTo.address,
        ]);
        const code = new HEXer_1.HEXer()
            .address(this.getProtocolExecutor())
            .bytes((0, viem_1.encodeAbiParameters)((0, viem_1.parseAbiParameters)('uint8, address, bytes'), [
            0, // isMetaSwap
            to,
            poolData,
        ]))
            .toString();
        return code;
    }
}
exports.CurveStablePoolCode = CurveStablePoolCode;
